import { useState } from "react"
import { Navigate } from "react-router-dom"
// import { FormattedMessage, useIntl } from 'react-intl';
import useUser from "hooks/useUser"
import MessagePage from "components/Page/MessagePage"
import { consumeHostedUIReturnRoute } from "auth/hostedUI"

const AuthenticatedCallbackRedirect = () => {
  const [target] = useState(() => consumeHostedUIReturnRoute())
  return <Navigate replace to={target} />
}

const CallbackView = () => {
  const user = useUser()

  // const { formatMessage: f } = useIntl()

  if (user) {
    return <AuthenticatedCallbackRedirect />
  }
  return (
    <MessagePage
      title="Done Authenticating"
      subTitle="If this page persists, please contact support"
    />
  )
}

export default CallbackView
